/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Other_LicenseInputs */

const en_footer_other_license = /** @type {(inputs: Footer_Other_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`License: CC-BY 4.0`)
};

/**
* | output |
* | --- |
* | "License: CC-BY 4.0" |
*
* @param {Footer_Other_LicenseInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_other_license = /** @type {((inputs?: Footer_Other_LicenseInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Other_LicenseInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_other_license(inputs)
});